import React from "react"
import { AuthCard } from "components/views/login/Shared"
import { HR, Spacer } from "../atoms/Atoms"
import { AuthLayout } from "./Shared"
import L10n from "../../../lib/carrot-l10n"
import { Body } from "../atoms/Bodies"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { H1 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const ResetPasswordSuccess = () => (
  <AuthLayout title={l`client.login`}>
    <AuthCard>
      <Spacer height={4} />
      <div className="flex flex-auto flex-column items-center">
        <H1>{l`client.success`}</H1>
        <Spacer height={0.75} />
        <Body align="tc" color="black-80">
          {l`client.yourPasswordHasBeenReset`}
        </Body>
        <Spacer height={1.5} />
        <div className="w-100">
          <HR color="light-gray" />
        </div>
        <Spacer height={0.75} />
        <ArrowLink to="/">{l`client.login`}</ArrowLink>
        <Spacer height={0.5} />
      </div>
    </AuthCard>
  </AuthLayout>
)

export default ResetPasswordSuccess
